/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:33:04
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-30 13:48:10
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\mutationTypes.js
 */
/* ----base----- */
export const SETRESEARCHRAUTHORITY = 'SETRESEARCHRAUTHORITY'// 研究权限
export const SETIDENTITYTYPE = 'SETIDENTITYTYPE'// 角色类型
/* ----research----- */
export const SETRESEARCHNAME = 'SETRESEARCHNAME'// 研究名称
export const SETRESEARCHCODE = 'SETRESEARCHCODE'// 研究code
export const SETRESEARCHINFO = 'SETRESEARCHINFO'// 研究info
/* ----testee----- */
export const SETTESTEEDETAIL = 'SETTESTEEDETAIL'// 受试者详情
export const SETTESTEEFORM = 'SETTESTEEFORM' // 受试者表单
export const SETCENTERNAME = 'SETCENTERNAME' // 受试者表单
/* ----center----- */
export const SETCENTERCODE = 'SETCENTERCODE' // 中心KEY
export const SETCENTERLIST = 'SETCENTERLIST' // 中心列表
/* ---recruit---- */
export const SETRECRUITFORM = 'SETRECRUITFORM' // 招募表单
